module.exports = __webpack_public_path__ + "static/img/news11.c12cac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news11.jpg
// module id = S+D/
// module chunks = 1